<template>
  <div v-if="field.options">
    <label class="subtitle-2 black--text pl-3">
      {{ field.label }}
      <span v-if="this.field.required==1" class="orange--text text--darken-3">*</span>
    </label>
    <div class="list">
      <v-checkbox
        v-for="option in field.options"
        :key="option.id"
        :value="option.value"
        v-model="selection"
        :label="label(option)"
      />
    </div>
    <div class="hint" v-if="field.hint">{{field.hint}}</div>
    <div class="errorMsg" v-if="block.errorMessages">{{block.errorMessages[0]}}</div>
  </div>
</template>
<script>
import FieldMixin from "./FieldMixin";
export default {
  mixins: [FieldMixin],
  name: "FieldCheckbox",
  data: function() {
    return {
      selection: []
    };
  },
  mounted() {
    this.selection = this.model;
  },
  watch: {
    selection: function(selection) {
      this.model = selection;
      this.update();
    }
  },
  computed: {
    selected: {
      get: function() {
        if (typeof this.model == Array) {
          return this.model;
        } else {
          return [];
        }
      },
      set: function(selected) {
        this.model = selected;
      }
    }
  },
  methods: {
    validate: function() {
      if (this.field.required === 1 && !this.model) {
        this.isValid = false;
        this.addError(this.block.id,"Champ obligatoire");
      } else {
        this.isValid = true;
      }
    },
    label(option) {
      let label = option.label;
      if (option.upcharge) {
        label += "( + " + option.upcharge + " CHF) ";
      }
      return label;
    }
  }
};
</script>
